/**
 * src/modules/monetization/context/AdEngineContext.tsx
 *
 * Privacy-First Native Ad Engine Context & Interfaces.
 * Enforces Zero-Tracking and strict tier-based gating.
 */

import { createContext, useContext } from 'react';

export interface AdPayload {
  adId: string;
  slotId: string;
  sponsorName: string;
  headline: string;
  bodyText: string;
  callToAction: string;
  targetUrl: string;
  imageUrl?: string;
  isRewardable?: boolean;
}

export interface AdEngineContextType {
  isAdFree: boolean;
  requestNativeAd: (slotId: string) => Promise<AdPayload | null>;
  recordImpression: (adId: string) => void;
  recordClick: (adId: string) => void;
  requestRewardedAd: (placementId: string) => Promise<boolean>;
}

export const AdEngineContext = createContext<AdEngineContextType | null>(null);

export function useAdEngine(): AdEngineContextType {
  const ctx = useContext(AdEngineContext);
  if (!ctx) {
    throw new Error('useAdEngine must be used within an AdEngineProvider');
  }
  return ctx;
}
